import tempMeeApi from '../../../apis/tempMee';

/**
 * Fetches payment plans from the API
 *
 * @returns {Promise<import('../types/PaymentPlan.api').IGetPaymentPlansApiResponse>} Payment plans API response
 */
export const getPaymentPlans = async () => {
  const response = await tempMeeApi.get('/payment/admin/plans');

  return response.data;
};
